import links from "../utils/links";
import { NavLink } from "react-router-dom";

const NavLinks = ({ toggleSidebar }) => {
  return (
    <div className="nav-links">
      {links.map((link) => {
        const { text, path, id, icon, intro, position } = link;
        return (
          <NavLink
            to={path}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            key={id}
            onClick={toggleSidebar}
            data-step={id}
            data-intro={intro}
            data-position={position}
          >
            <span className="icon">{icon}</span>
            <span className="nav-text">{text}</span>
          </NavLink>
        );
      })}
    </div>
  );
};
export default NavLinks;
